/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { DailyActivityMonitoringLogHeaderDto } from './dailyActivityMonitoringLogHeaderDto.schema';

export const SubmitDailyActivityMonitoringLogHeader = zod.object({
  "id": zod.string().uuid().optional(),
  "payload": zod.lazy(() => DailyActivityMonitoringLogHeaderDto).optional()
});

export type SubmitDailyActivityMonitoringLogHeader = zod.input<typeof SubmitDailyActivityMonitoringLogHeader>;
export type SubmitDailyActivityMonitoringLogHeaderOutput = zod.output<typeof SubmitDailyActivityMonitoringLogHeader>;
